'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.QueryNodeWalkerContext = undefined;

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _QueryNodeRegistry = require('../QueryNodeRegistry');

var _QueryNodeRegistry2 = _interopRequireDefault(_QueryNodeRegistry);

var _ValueSetRegistry = require('../ValueSetRegistry');

var _ValueSetRegistry2 = _interopRequireDefault(_ValueSetRegistry);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QueryNodeWalkerContext = exports.QueryNodeWalkerContext = function () {
    function QueryNodeWalkerContext() {
        (0, _classCallCheck3.default)(this, QueryNodeWalkerContext);

        this._visitTypeStack = [];
        this._currentNodeStack = [];
        this._parentNodeStack = [];
        this._pathStack = [];
        this._skipChildren = false;
        this._skipData = false;
    }

    (0, _createClass3.default)(QueryNodeWalkerContext, [{
        key: 'pushVisitType',
        value: function pushVisitType(type) {
            this._visitTypeStack.push(type);
        }
    }, {
        key: 'popVisitType',
        value: function popVisitType() {
            this._visitTypeStack.pop();
        }
    }, {
        key: 'pushNode',
        value: function pushNode(currentNode) {
            this._currentNodeStack.push(currentNode);
            this._parentNodeStack.push(currentNode.parentNode);
        }
    }, {
        key: 'popNode',
        value: function popNode() {
            this._currentNodeStack.pop();
            this._parentNodeStack.pop();
        }
    }, {
        key: 'pushPath',
        value: function pushPath(pathLevel) {
            this._pathStack.push(pathLevel);
        }
    }, {
        key: 'popPath',
        value: function popPath() {
            this._pathStack.pop();
        }
    }, {
        key: 'getVisitMethod',
        value: function getVisitMethod(visitor) {
            switch (this.visitType) {
                case 'data':
                    return visitor.visitData;
                case 'valueSet':
                    return QueryNodeWalkerContext.searchForAncestorMethod(visitor, _ValueSetRegistry2.default, this.currentValueSet.type, 'visitValueSet');
                case 'node':
                    return QueryNodeWalkerContext.searchForAncestorMethod(visitor, _QueryNodeRegistry2.default, this.currentNode.type, 'visitQueryNode');
                default:
                    return null;
            }
        }
    }, {
        key: 'path',
        get: function get() {
            return [].concat((0, _toConsumableArray3.default)(this._pathStack));
        }
    }, {
        key: 'depth',
        get: function get() {
            return this._currentNodeStack.length;
        }
    }, {
        key: 'visitType',
        get: function get() {
            return (0, _lodash.last)(this._visitTypeStack);
        }
    }, {
        key: 'currentNode',
        get: function get() {
            return (0, _lodash.last)(this._currentNodeStack);
        }
    }, {
        key: 'parentNode',
        get: function get() {
            return (0, _lodash.last)(this._parentNodeStack);
        }
    }, {
        key: 'currentValueSet',
        get: function get() {
            return this._currentValueSet;
        },
        set: function set(value) {
            this._currentValueSet = value;
        }
    }, {
        key: 'currentDataKey',
        get: function get() {
            return this._currentDataKey;
        },
        set: function set(value) {
            this._currentDataKey = value;
        }
    }, {
        key: 'currentDataValue',
        get: function get() {
            return this._currentDataValue;
        },
        set: function set(value) {
            this._currentDataValue = value;
        }
    }, {
        key: 'startingNode',
        get: function get() {
            return this._startingNode;
        },
        set: function set(value) {
            this._startingNode = value;
        }
    }, {
        key: 'appContext',
        get: function get() {
            return this._appContext;
        },
        set: function set(value) {
            this._appContext = value;
        }
    }, {
        key: 'skipData',
        get: function get() {
            return this._skipData;
        },
        set: function set(value) {
            this._skipData = value;
        }
    }, {
        key: 'skipChildren',
        get: function get() {
            return this._skipChildren;
        },
        set: function set(value) {
            this._skipChildren = value;
        }
    }], [{
        key: 'getVisitorName',
        value: function getVisitorName(name) {
            return 'visit' + name;
        }
    }, {
        key: 'checkName',
        value: function checkName(visitor, name) {
            return typeof visitor[name] === 'function';
        }
    }, {
        key: 'searchForAncestorMethod',
        value: function searchForAncestorMethod(visitor, registry, type, defaultMethodName) {
            var methodName = QueryNodeWalkerContext.getVisitorName(type);
            if (QueryNodeWalkerContext.checkName(visitor, methodName)) {
                return visitor[methodName];
            } else {
                var ancestorNames = registry.getAncestorChain(type);
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = (0, _getIterator3.default)(ancestorNames), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var ancestor = _step.value;

                        methodName = QueryNodeWalkerContext.getVisitorName(ancestor);
                        if (QueryNodeWalkerContext.checkName(visitor, methodName)) {
                            return visitor[methodName];
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
            return visitor[defaultMethodName];
        }
    }]);
    return QueryNodeWalkerContext;
}();

exports.default = QueryNodeWalkerContext;